module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14OE8G7/tc-custom/9780062190581.jpg?1726519033411",
      "alt": "This image is the cover for the book Charlotte Street"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Charlotte Street\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“Unmissable...will have you laughing out loud and melt your heart, all at once.”"), _c('br'), _vm._v("—"), _c('i', [_vm._v("Cosmopolitan ")]), _vm._v("(UK)")]), _c('p', [_c('br'), _vm._v("Danny Wallace is a British writer, producer, and award-winning journalist whom "), _c('i', [_vm._v("GQ")]), _vm._v(" (UK) calls, “One of Britain’s great writing talents.” The man who gave us "), _c('i', [_vm._v("Yes Man")]), _vm._v(" (basis for the Hollywood motion picture starring Jim Carrey and Zooey Deschanel) makes a grand foray into fiction with "), _c('i', [_vm._v("Charlotte Street")]), _vm._v(", a sweet and sharp romantic comedy about finding love, growing up, and making your own fate that fans of the novels of Nick Hornby and David Nicholls are going to adore. With this charming, slightly twisted comic novel about an endearing loser’s convoluted plot to turn a brief chance meeting into a once-in-a-lifetime love affair, Wallace proves he has ample heart to go along with the humor. "), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Danny Wallace\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0